import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import {
  Grid,
  IconButton,
  Typography,
  FormLabel,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { REMARK_VALIDATION } from "../../utils/Validation";

export default function CancelAppointmentPopup({
  handleClose,
  dialogOpen,
  cancelAppointment,
  onClickYes,
}) {
  const formOption = {
    resolver: yupResolver(REMARK_VALIDATION),
  };
  const {
    register,
    handleSubmit,
    formState: { errors },

    reset,
  } = useForm(formOption);
  const onSubmit = (data) => {
    onClickYes(data?.remark);
    reset();
  };
  useEffect(() => {
    reset();
  }, [dialogOpen, reset]);

  return (
    <div>
      <Dialog
        PaperProps={{
          style: {
            borderLeft: "2px red solid",
          },
        }}
        open={dialogOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{ px: 3 }}>
          <Typography variant="h6" gutterBottom>
            {"Cancel Confirm"}{" "}
          </Typography>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ px: 6 }}>
          <Typography gutterBottom>
            Are you sure you want to cancel appointment{" "}
            <b> {cancelAppointment?.appointmentId} </b> ?
          </Typography>
          <Grid
            container
            spacing={1}
            direction="row"
            justifyContent="left"
            alignItems="center"
            sx={{ pt: 1 }}
          >
            <Grid item xs={12} sm={12} alignSelf="cennter">
              <FormLabel
                required={true}
                sx={{
                  float: "left",
                  fontSize: 13,
                  color: "black",
                }}
              >
                Remark
              </FormLabel>
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                style={{
                  border: Boolean(errors?.remark) ? "1px solid red" : "",
                  width: "100%",
                }}
                sx={{ color: "#767676", width: "100%" }}
                name="remark"
                required
                multiline
                placeholder="Please Enter The Remark"
                rows={3}
                size="small"
                autoComplete="off"
                {...register("remark", {
                  required: true,
                })}
                error={Boolean(errors?.remark)}
                helperText={errors?.remark?.message}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSubmit(onSubmit)} autoFocus color="error">
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
